<template>
    <div>    
        <div class="breadcrumbs-container">
            <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
            <ul>
                <li>
                  <router-link :to="{name: 'Home'}">  
                    Home
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name: 'Kitchen', params: {id: menuData.user_id}}">  
                    {{menuData.kitchen_name}}'s Kitchen
                  </router-link>                        
                </li>
                <li class="is-active">
                  <a href="#">  
                      {{menuData.name}}
                  </a>                        
                </li>
            </ul>
            </nav>
        </div>
        <section>    
            <div class="container">    
                        <div>
                            <div class="circular" v-if="menuData.mainImage" :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menuData.mainImage + '?alt=media)' }" />
                            <!-- <div class="circular" v-else :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menuData.recipes[0].mainImage[0] + '?alt=media)' }" /> -->
                        </div>                               
                        <!-- Post meta -->    
                        <div class="is-size-1 has-text-centered">       
                            <span class="is-capitalized caveat">    
                                {{menuData.name}}    
                            </span>  
                        </div>    
                        <!-- subtitle -->  
                        <p class="is-size-5 has-text-centered mb-50 radley">{{menuData.subtitle}}</p>   
                        
                <div class="columns is-multiline">    
                    <div v-for="recipes in menuData.menu" :key="recipes.id" class="column is-one-third">
                    <!-- <button class="button is-primary add-rounded mt-5" slot="trigger"                            
                        @click="openModal(recipe)">
                        <b-icon icon="plus"></b-icon>
                    </button> -->
                        <div>    
                            <span class="is-size-4">{{recipes.dishType}}</span>
                            <div v-for="recipe in recipes.recipes" :key="recipe.id">
                            <a @click="openModal(recipe)" 
                            class="is-size-4 caveat">
                            {{recipe.name}}</a>    
                            </div>
                        </div>
                    </div>
                </div> 
            </div>    
        </section>    
        <!-- /Post section -->
        <b-modal :active.sync="isComponentModalActive"
            has-modal-card full-screen :can-cancel="false">
            <Recipe :selectedRecipe="selectedRecipe"></Recipe>
        </b-modal>  
    </div>
</template>

<script>
import firebase from '@/firebase';
import db from '@/db';
import moment from 'moment';
import { mapState } from 'vuex';
import Recipe from '../components/Recipe.vue';

export default {

    name: "Menu",
    data() {
        return {
            id: this.$route.params.id,
            likeableRef: Object,
            ratingRef: Object,
            user_id: null,            
            menuData: {
                prepTime: {
                    hours: 0,
                    minutes: 0
                },
                cookTime: {
                    hours: 0,
                    minutes: 0
                }
            },
            userData:Object,
            created_at: String,
            isActive: false,
            rating: null,
            latestRecipes: [],
            isComponentModalActive: false,
            selectedRecipe:Object,
        }
    },
    components: {
        Recipe
    },
    async mounted() {
        const vm = this;
        await this.fetchData();
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.user_id = user.uid;
                this.likeableRef = db.collection('dishLikeables').doc(this.user_id + ':' + this.id);
                this.ratingRef = db.collection('dishRatings').doc(this.user_id + ':' + this.id);
                this.likeableRef.get().then(function(doc) {
                    if (doc.exists) {
                        vm.isActive = true;
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
                this.ratingRef.get().then(function(doc) {
                    if (doc.exists) {
                        vm.rating = doc.data().rating;
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            } else {
                console.log("not logged in");
            }
        });
    },
    watch: {
        "$route": "fetchData"
    },
    computed: mapState('auth', ['user', 'isLoggedIn']),
    methods: {
        fetchData() {
            db.collection('menus').doc(this.id)
                .get().then(docSnapshot => {
                    if (!docSnapshot.exists) return;
                    this.menuData = docSnapshot.data()
                    this.created_at = moment(this.menuData.created_at.toDate()).fromNow();
                        db.collection('users').doc(this.menuData.user_id)
                        .get().then(docSnapshot => {
                            if (!docSnapshot.exists) return;
                            this.userData = docSnapshot.data()
                        });
                });
        },
        openModal(recipe) {
                this.isComponentModalActive = true;
                this.selectedRecipe = recipe;
        },
    }
}
</script>
